import { render, staticRenderFns } from "./PagesFeedWidget.vue?vue&type=template&id=5e0f34e8&"
import script from "./PagesFeedWidget.vue?vue&type=script&lang=js&"
export * from "./PagesFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0f34e8')) {
      api.createRecord('5e0f34e8', component.options)
    } else {
      api.reload('5e0f34e8', component.options)
    }
    module.hot.accept("./PagesFeedWidget.vue?vue&type=template&id=5e0f34e8&", function () {
      api.rerender('5e0f34e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/PagesFeedWidget.vue"
export default component.exports